import { render, staticRenderFns } from "./ExhibitionQid.vue?vue&type=template&id=80fa7b78"
import script from "./ExhibitionQid.vue?vue&type=script&lang=js"
export * from "./ExhibitionQid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports